import { render } from "./InstagramFeed.vue?vue&type=template&id=3bfb245e&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"

import "./InstagramFeed.vue?vue&type=style&index=0&id=3bfb245e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfb245e"]])

export default __exports__